module.exports = "<h5 class=\"t-h5\">{{content.errorcode==\"\"?\"\":content.errorcode + \" : \"}} {{content.errormessage}}</h5>";
